import React, { Fragment, useState } from "react";
import { Col, Modal } from "react-bootstrap";
import play from "../../assets/play.svg";

const RazonCinco = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <Fragment>
      <Col
        lg={6}
        className="contentCards cardLigth "
        id="razonCinco"
        data-aos="zoom-in"
        data-aos-offset="300"
        data-aos-duration="1000"
        data-aos-easing="ease-out"
      >
        <h4>Razón #5</h4>
        <h2 data-aos="fade-left" data-aos-offset="300" data-aos-duration="500">
          Tecnología
        </h2>
        <p data-aos="fade-left" data-aos-offset="300" data-aos-duration="500">
          Última tecnología aplicada a tu piscina.{" "}
        </p>

        <p data-aos="fade-left" data-aos-offset="300" data-aos-duration="500">
          Con desarrollos de diseño propios e innovación patentados.
        </p>
        <div data-aos="zoom-in" data-aos-offset="300" data-aos-duration="500">
          <iframe
            width="100%"
            height="330px"
            src="https://www.youtube.com/embed/Qy7HrO0s6vc"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </Col>
    </Fragment>
  );
};

export default RazonCinco;
